// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__hU2GC","title":"BackImages_title__3rvy6","images":"BackImages_images__1bqMB"};